/* global globalThis */
import * as React from "react";
import PropTypes from "prop-types";
import { Box, Button } from "@material-ui/core";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { useTranslations } from "sdk/custom-hooks";
import useStyles from "sdk/custom-hooks/useStyles";

/**
 * Single question solution modal.
 * @param props
 * @returns {*}
 * @constructor
 */

function QuestionSolutionModal(props) {
  const { question } = props;
  const t = useTranslations();
  const classes = useStyles(styles)();
  const solution = question?.id;
  const baseUrl = globalThis.location?.origin || "";
  const linkSolutionUrl = solution?.solutionLink;
  const fileSolutionUrl = solution?.featured?.original?.pdf
    ? `${baseUrl}${solution.featured.original.pdf}`
    : undefined;
  const hasLinkSolution =
    solution?.solutionType === "PDF" &&
    solution?.solutionPdfType === "LINK" &&
    Boolean(linkSolutionUrl);
  const hasFileSolution =
    solution?.solutionType === "PDF" &&
    solution?.solutionPdfType === "FILE" &&
    Boolean(fileSolutionUrl);

  return (
    <Box>
      {hasLinkSolution && (
        <><Box>{t('VIEW_SOLUTION')}</Box>
        <Box className={classes.solutionText}>
        <Button className={classes.buttonText}>
          <a href={linkSolutionUrl} target="_blank" rel="noreferrer" className={classes.urlLink}>
          <Box className={classes.iconButton}>
            <PictureAsPdfIcon />
            <p>{t("PDF")}</p>
          </Box>
          </a>
        </Button>
        </Box>
        </>
      )}

      {hasFileSolution && (
        <><span>{t('VIEW_SOLUTION')}</span>
        <span className={classes.solutionText}>
        <Button className={classes.buttonText}>
          <a href={fileSolutionUrl} target="_blank" rel="noreferrer" className={classes.urlLink}>
            <Box className={classes.iconButton}>
              <PictureAsPdfIcon />
              <p>{t("PDF")}</p>
            </Box>
          </a>
        </Button>
        </span>
        </>
      )}
      <Box className={classes.viewSolutionModal}>
      </Box>
    </Box>
  );
}

const styles = (theme) => ({
  buttonText: {
    boxShadow: "#D7CCFF",
    width: "100px",
    height: "35px",
    background: "#5F4BAB",
    color: "#ffffff",
    border: "1px solid #5F4BAB",
    "&:hover": {
      background: "#5F4BAB",
    },
  },
  solutionText: {
    marginLeft: 15
  },
  urlLink: {
    color: '#fff',
    textDecoration: 'none'
  },
  iconButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding:50
  },
});

QuestionSolutionModal.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.shape({
      solutionType: PropTypes.string,
      solutionPdfType: PropTypes.string,
      solutionLink: PropTypes.string,
      featured: PropTypes.shape({
        original: PropTypes.shape({
          pdf: PropTypes.string,
        }),
      }),
    }),
  }),
};

export default QuestionSolutionModal;
